import React, { cloneElement } from 'react';
import { useClipboard } from '../../../../hooks/use-clipboard.js';
import '../../../../utilities/color.js';
import 'date-fns';
import '../../../../utilities/locale.js';
import '../../../../hooks/use-prevent-keyboard-scrolling.js';
import '../../tooltip/hover-tooltip/hover-tooltip.js';
import 'classnames';
import '../../icon/font-icon/font-icon.js';
import 'react-laag';
import 'react-transition-group';
import '../../../../styles/styled-components/alert.js';
import '../../../../styles/styled-components/animations.js';
import '../../../../styles/styled-components/box-shadow.js';
import '../../../../styles/styled-components/button.js';
import 'styled-components';
import '../../../../themes/alert.js';
import '../../../../themes/button.js';
import '../../../../themes/checkbox.js';
import '../../../../themes/divider.js';
import '../../../../themes/dropdown.js';
import '../../../../themes/fieldset.js';
import '../../../../themes/input.js';
import '../../../../themes/list.js';
import '../../../../themes/listbox.js';
import '../../../../themes/loader.js';
import '../../../../themes/option.js';
import '../../../../themes/popout.js';
import '../../../../themes/switch.js';
import '../../../../themes/themes.js';
import '../../../../themes/tooltip.js';
import '../../../../styles/styled-components/font-face.js';
import '../../../../styles/styled-components/global.js';
import '../../../../styles/styled-components/input.js';
import '../../../../styles/styled-components/list.js';
import '../../../../styles/styled-components/listitem.js';
import '../../../../styles/styled-components/media-queries.js';
import '../../../../styles/styled-components/reset.js';
import '../../../../styles/styled-components/outline.js';
import '../../../../styles/styled-components/popout.js';
import '../../../../styles/styled-components/screen-reader.js';
import '../../../../styles/styled-components/switch.js';
import '../../../../styles/styled-components/tooltip.js';
import { StandardTooltip } from '../../tooltip/standard-tooltip/standard-tooltip.js';

/**
 * `<CopyButton>` is a wrapper component around any `<button>` component (such as `<StandardButton>` or `<IconButton>`)
 * that allows for copying string data to a users' clipboard via Clipboard API
 * and that shows a brief `<StandardTooltip>` message when copied successfully.
 *
 * This component assumes browser support for the [Clipboard API](https://developer.mozilla.org/en-US/docs/Web/API/Clipboard_API) `writeText` event.
 *
 * `id` prop is required and will be applied to your `<button>` component.
 * If your `<button>` needs to do `onClick` things in addition to copying, pass an `onClick` prop to
 * `<CopyButton onClick={() => {}}>` instead of your `<button>`.
 *
 * You can pass props to the `<StandardTooltip>` via the `tooltipProps` prop.
 * Some props won't be honored as they are internally controlled within this component
 * (`defaultOpen`, `id`, `openOnFocus`, `openOnHover`, and `tooltip`).
 *
 * If you need more control over the copy to clipboard experience, consider using
 * the `useClipboard` React hook with your own component.
 *
 * @param props CopyButtonProps
 * @returns FunctionComponent<CopyButtonProps>
 */ const CopyButton = (props)=>{
    const { children, data, delay, id, onClick, tooltip, tooltipProps } = props;
    const { copied, copy } = useClipboard({
        delay
    });
    const tooltipId = `${id}-tooltip`;
    return /*#__PURE__*/ React.createElement(StandardTooltip, {
        ...tooltipProps,
        defaultOpen: copied || undefined,
        id: tooltipId,
        openOnFocus: false,
        openOnHover: false,
        tooltip: tooltip
    }, /*#__PURE__*/ cloneElement(children, {
        id: id,
        onClick: (e)=>{
            copy(data);
            if (onClick) {
                onClick(e);
            }
        }
    }));
};

export { CopyButton };
//# sourceMappingURL=copy-button.js.map
